<div class="admin-panel">
    <div class="admin-panel__header">
        <h1 class="header__title">פאנל הניהול</h1>

        <button class="header__close" (click)="closeDialog()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>

    <div class="admin-panel__body">
        <div class="admin-panel__preview admin-panel__preview_size_large">
            <div class="preview__card">
                <img *ngIf="adminpanel_params.logo" class="preview__logo" [src]="adminpanel_params.logo" />
                <img *ngIf="!adminpanel_params.logo" class="preview__logo" src="/assets/img/Automation/icon_cloud-upload_logo.png" />

                <h3 class="preview__title">
                    ,חיים <br />
                    מחכים לך מחר ב 18:00
                </h3>

                <span class="preview__text"> ... לטיפול פנים קלאסי, מניקור קלאסי, בנייה בגיל אצל <strong>נטלי קוסמטיקס</strong></span>

                <div class="preview__button preview__button_size_large preview__button_theme_green">
                    !סגור, אני מגיע/ה
                    <img class="preview__button-icon" src="/assets/img/Automation/w-g-check-mark.png" />
                </div>

                <div *ngIf="adminpanel_params.showCallOption" class="preview__button preview__button_theme_gray">
                    להתקשר לשינוי מועד
                    <img class="preview__button-icon" src="/assets/img/Automation/icon_phone.png" />
                </div>

                <div *ngIf="adminpanel_params.showCancelOption" class="preview__button preview__button_theme_red">
                    לביטול התור
                    <img class="preview__button-icon" src="/assets/img/Automation/icon-cross.png" />
                </div>
            </div>
        </div>

        <div class="admin-panel__preview-wrapper" [ngClass]="{ 'admin-panel__preview-wrapper_visible': isPreviewVisible }">
            <div class="admin-panel__preview admin-panel__preview_size_small" [ngClass]="{ 'admin-panel__preview_visible': isPreviewVisible }">
                <div class="preview__card">
                    <img *ngIf="adminpanel_params.logo" class="preview__logo" [src]="adminpanel_params.logo" />
                    <img *ngIf="!adminpanel_params.logo" class="preview__logo" src="/assets/img/Automation/icon_cloud-upload_logo.png" />

                    <h3 class="preview__title">
                        ,חיים <br />
                        מחכים לך מחר ב 18:00
                    </h3>

                    <span class="preview__text"> ... לטיפול פנים קלאסי, מניקור קלאסי, בנייה בגיל אצל <strong>נטלי קוסמטיקס</strong></span>

                    <div class="preview__button preview__button_size_large preview__button_theme_green">
                        !סגור, אני מגיע/ה
                        <img class="preview__button-icon" src="/assets/img/Automation/w-g-check-mark.png" />
                    </div>

                    <div *ngIf="adminpanel_params.showCallOption" class="preview__button preview__button_theme_gray">
                        להתקשר לשינוי מועד
                        <img class="preview__button-icon" src="/assets/img/Automation/icon_phone.png" />
                    </div>

                    <div *ngIf="adminpanel_params.showCancelOption" class="preview__button preview__button_theme_red">
                        לביטול התור
                        <img class="preview__button-icon" src="/assets/img/Automation/icon-cross.png" />
                    </div>
                </div>
            </div>

            <button class="button button_with-icon button_size_small button_theme_main preview__button_close" (click)="hidePreview()">
                חזור
                <i class="fa-solid fa-arrow-right"></i>
            </button>
        </div>

        <div class="admin-panel__settings">
            <div class="settings__logo-layout">
                <div class="settings__logo-buttons">
                    <button
                        class="button button_size_small button_with-icon button_theme_main-line settings__logo-button"
                        [disabled]="!adminpanel_params.logo"
                        (click)="clearLogo()"
                    >
                        נקה לוגו
                        <i class="fa-regular fa-trash-can"></i>
                    </button>

                    <label class="button button_size_small button_with-icon button_theme_main-line settings__logo-button">
                        עיון
                        <i class="fa-regular fa-cloud-arrow-up"></i>
                        <input class="logo-button__input" type="file" (change)="uploadImage($event.target)" accept=".jpeg, .jpg, .png" />
                    </label>
                </div>

                <div class="settings__logo-text">
                    <span class="settings__logo-icon">
                        <i class="fa-regular fa-image"></i>
                    </span>

                    <span>(kB 40 עד) טען לוגו</span>

                    <img *ngIf="adminpanel_params.logo" class="settings__logo-image" [src]="adminpanel_params.logo" />
                    <img *ngIf="!adminpanel_params.logo" class="settings__logo-image" src="/assets/img/Automation/icon_cloud-upload_logo.png" />

                    <div class="settings__logo-error" [ngClass]="{ 'settings__logo-error_visible': !isSizeValid && isFileValid }">
                        גודל הקובץ צריך להיות פחות מ-40KB
                    </div>
                    <div class="settings__logo-error" [ngClass]="{ 'settings__logo-error_visible': !isFileValid }">
                        הקובץ חייב להיות עם סוג .jpg, .jpeg או .png
                    </div>
                </div>
            </div>

            <span class="separator"></span>

            <label class="checkbox-label settings__checkbox-label">
                אפשר להתקשר כדי לשנות את מועד הפגישה
                <input class="checkbox" [(ngModel)]="adminpanel_params.showCallOption" type="checkbox" (change)="callOptionChange()" />
                <span class="custom-checkbox"></span>
            </label>

            <div class="settings__input-layout" [ngClass]="{ settings__item_hidden: !adminpanel_params.showCallOption }">
                <span class="settings__input-text"> הטלפון אליו יגיעו השיחות </span>

                <div class="input-wrapper" [ngClass]="{ 'input-wrapper_error': !isPhoneToCallValid }">
                    <input
                        #inputPhoneToCall
                        class="input"
                        [(ngModel)]="adminpanel_params.phoneToCall"
                        type="tel"
                        inputmode="tel"
                        maxlength="10"
                        pattern="05[0-9]{8}"
                        autocomplete="off"
                    />
                </div>
            </div>

            <span class="separator"></span>

            <label class="checkbox-label settings__checkbox-label">
                אפשר לבטל את הפגישה
                <input class="checkbox" [(ngModel)]="adminpanel_params.showCancelOption" type="checkbox" (change)="cancelOptionChange()" />
                <span class="custom-checkbox"></span>
            </label>

            <div
                class="input-wrapper input-wrapper_with-label input-wrapper_type_range settings__range"
                [ngClass]="{ 'input-wrapper_disabled': !adminpanel_params.showCancelOption }"
            >
                <span class="input-label">שעות לפני הפגישה</span>

                <div class="range">
                    <button
                        class="range__button range__button_plus"
                        [disabled]="!adminpanel_params.showCancelOption"
                        (click)="timeValueIncrement(24)"
                    >
                        <i class="fa-regular fa-plus"></i>
                    </button>
                    <input
                        class="input"
                        [(ngModel)]="adminpanel_params.allowCancelBeforeHours"
                        [disabled]="!adminpanel_params.showCancelOption"
                        (focus)="onRangeFocus($event.target)"
                        (input)="onRangeChange($event.target, 1, 24)"
                    />
                    <button
                        class="range__button range__button_minus"
                        [disabled]="!adminpanel_params.showCancelOption"
                        (click)="timeValueDecrement(1)"
                    >
                        <i class="fa-regular fa-minus"></i>
                    </button>
                </div>

                <span class="input-label">אפשר לבטל רק עד</span>
            </div>

            <div class="settings__input-layout">
                <label class="checkbox-label settings__checkbox-label" [ngClass]="{ 'checkbox-label_disabled': !adminpanel_params.showCancelOption }">
                    שלח לי סמס על כל ביטול פגישה לטלפונים הבאים
                    <input
                        class="checkbox"
                        [(ngModel)]="adminpanel_params.canSendSmsonCancel"
                        type="checkbox"
                        [disabled]="!adminpanel_params.showCancelOption"
                        (change)="sendCancelMeetingChange()"
                    />
                    <span class="custom-checkbox"></span>
                </label>

                <div
                    class="input-wrapper"
                    [ngClass]="{
                        'input-wrapper_error': !isFirstPhoneToSendValid,
                        settings__item_hidden: !adminpanel_params.showCancelOption || !adminpanel_params.canSendSmsonCancel
                    }"
                >
                    <input
                        #inputFirstPhoneToSendCancel
                        class="input"
                        [(ngModel)]="adminpanel_params.phoneToSendonCancel1"
                        type="tel"
                        inputmode="tel"
                        maxlength="10"
                        pattern="05[0-9]{8}"
                        [disabled]="!adminpanel_params.showCancelOption"
                        autocomplete="off"
                    />
                </div>

                <div
                    class="input-wrapper"
                    [ngClass]="{
                        'input-wrapper_error': !isSecondPhoneToSendValid,
                        settings__item_hidden: !adminpanel_params.showCancelOption || !adminpanel_params.canSendSmsonCancel
                    }"
                >
                    <input
                        #inputSecondPhoneToSendCancel
                        class="input"
                        [(ngModel)]="adminpanel_params.phoneToSendonCancel2"
                        type="tel"
                        inputmode="tel"
                        maxlength="10"
                        pattern="05[0-9]{8}"
                        [disabled]="!adminpanel_params.showCancelOption"
                        autocomplete="off"
                    />
                </div>
            </div>

            <div class="settings__input-layout">
                <label class="checkbox-label settings__checkbox-label" [ngClass]="{ 'checkbox-label_disabled': !adminpanel_params.showCancelOption }">
                    שלח לי הודעת אזהרה אם לקוח מנסה לבטל פגישה פחות מ{{ adminpanel_params.allowCancelBeforeHours }} שעות לפני
                    <input
                        class="checkbox"
                        [(ngModel)]="adminpanel_params.canSendSmsToInform"
                        type="checkbox"
                        [disabled]="!adminpanel_params.showCancelOption"
                        (change)="sendWarningChange()"
                    />
                    <span class="custom-checkbox"></span>
                </label>

                <div
                    class="input-wrapper"
                    [ngClass]="{
                        'input-wrapper_error': !isFirstPhoneToSendWarningValid,
                        settings__item_hidden: !adminpanel_params.showCancelOption || !adminpanel_params.canSendSmsToInform
                    }"
                >
                    <input
                        #inputFirstPhoneToSendInform
                        class="input"
                        [(ngModel)]="adminpanel_params.phoneToSendToInform1"
                        type="tel"
                        inputmode="tel"
                        maxlength="10"
                        minlength="1"
                        pattern="05[0-9]{8}"
                        [disabled]="!adminpanel_params.showCancelOption"
                        autocomplete="off"
                    />
                </div>

                <div
                    class="input-wrapper"
                    [ngClass]="{
                        'input-wrapper_error': !isSecondPhoneToSendWarningValid,
                        settings__item_hidden: !adminpanel_params.showCancelOption || !adminpanel_params.canSendSmsToInform
                    }"
                >
                    <input
                        #inputSecondPhoneToSendInform
                        class="input"
                        [(ngModel)]="adminpanel_params.phoneToSendToInform2"
                        type="tel"
                        inputmode="tel"
                        maxlength="10"
                        pattern="05[0-9]{8}"
                        [disabled]="!adminpanel_params.showCancelOption"
                        autocomplete="off"
                    />
                </div>
            </div>

            <span class="separator"></span>

            <h3 class="settings__title">הודעה ללקוח לאחר אישור הפגישה</h3>

            <div class="input-wrapper input-wrapper_with-details input-wrapper_type_textarea settings__textarea">
                <textarea
                    class="input custom-scrollbar"
                    [(ngModel)]="adminpanel_params.afterConfMsg"
                    maxlength="175"
                    [disabled]="!adminpanel_params.canSendSmsToInform && !adminpanel_params.canSendSmsonCancel"
                ></textarea>
                <span class="input-details">אורך ההודעה {{ getTextLength() }} תווים (מתוך 175 תווים מותרים) </span>
            </div>
        </div>
    </div>

    <div class="admin-panel__footer">
        <button
            class="button button_size_small button_with-icon button_theme_main-line footer__button footer__button-preview"
            (click)="showPreview()"
        >
            תצוגה מקדימה
            <i class="fa-regular fa-eye"></i>
        </button>

        <button class="button button_size_small button_with-icon button_theme_main footer__button" (click)="saveData()">
            שמירה וסגירה
            <i class="fa-regular fa-floppy-disk"></i>
        </button>
    </div>
</div>

<p-dialog
    [ngClass]="{ 'custom-dialog': isConfirmDialogVisible }"
    styleClass="modal modal_type_confirm"
    [(visible)]="isConfirmDialogVisible"
    header="אזהרה"
    [modal]="true"
    [resizable]="false"
    [draggable]="false"
>
    <div class="modal__text">האם אתה בטוח שאתה רוצה לצאת בלי לסיים את העריכה?</div>
    <div class="modal__footer">
        <button class="button button_size_small button_theme_main" (click)="closeConfirmDialog(true)">לצאת</button>
        <button class="button button_size_small button_theme_main-line" (click)="closeConfirmDialog(false)">לחזור</button>
    </div>
</p-dialog>
